const appConstant = {
    // CUSTOMER_ID:1850,
    User_PROFILE:'User_PROFILE',
    CUSTOMER_PROFILE:'Customer_PROFILE',
    GOOGLE_MAPS_API_KEY : 'AIzaSyBk1NJgUjcjT-z48cCynTd-qIjayChB90Q',
}
export default appConstant;
